import productsJson from './products.json'

export const products = productsJson
